// 二手车销售管理
export default [
    {
      path: '/usedCar',
      name: 'usedCar',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/usedCar/usedCar.vue'], resolve)
      }
    },
    
  
  ]
  


// WEBPACK FOOTER //
// ./src/router/usedCar.js